import Vue from 'vue'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'

export default function usePackingMaterialsFetcher(vm) {
  const state = Vue.observable({
    fetcher: undefined,
  })

  const initializeFetcherPackingMaterials = () => {
    const fnFetch = ({
      offset, limit, search, warehouseId,
    }) => vm.$http_new.get(`/komship/api/v1/packing-materials/warehouses/${warehouseId}`, {
      params: {
        offset,
        limit,
        search,
      },
    }).then(res => {
      const { data } = res.data
      const mappedData = data.map(item => ({
        name: item.name,
        layer: 0,
        id: item.id,
      }))
      return {
        data: mappedData,
      }
    }).catch(error => {
      console.error(error)
      vm.$toast_error({
        message: 'Gagal mengambil data bahan packing, silahkan coba lagi',
      })
      return {
        data: [],
      }
    })

    state.fetcher = createPaginatedFetcher(fnFetch, 0, 50)
  }

  return {
    state,
    initializeFetcherPackingMaterials,
  }
}
